<template>
  <div class="json-editor">
    <textarea ref="textarea"></textarea>
    <div class="json-editor__error" v-if="jsonError">{{ jsonError }}</div>
  </div>
</template>
<script>
import CodeMirror from 'codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/eclipse.css'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/edit/matchbrackets'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/brace-fold'

export default {
  props: {
    value: { type: String, default: '' }
  },
  data() {
    return {
      editor: null,
      jsonError: null
    }
  },
  mounted() {
    this.editor = CodeMirror.fromTextArea(this.$refs.textarea, {
      mode: 'application/json',
      theme: 'eclipse',
      lineNumbers: true,
      lineWrapping: true,
      matchBrackets: true,
      foldGutter: true,
      gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
      tabSize: 2
    })
    this.editor.setSize('100%', '450px')
    this.editor.setValue(this.value || '')
    this.editor.on('change', instance => {
      const newValue = instance.getValue()
      this.validate(newValue)
      this.$emit('input', newValue)
    })
    this.validate(this.value)
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.toTextArea()
    }
  },
  watch: {
    value(newValue) {
      if (this.editor && newValue !== this.editor.getValue()) {
        this.editor.setValue(newValue || '')
      }
    }
  },
  methods: {
    validate(value) {
      if (!value) {
        this.jsonError = null
        return
      }
      try {
        JSON.parse(value)
        this.jsonError = null
      } catch (e) {
        this.jsonError = `Nieprawidłowy JSON: ${e.message}`
      }
    }
  }
}
</script>
<style scoped>
.json-editor__error {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 5px;
}
</style>
<style>
.json-editor .CodeMirror {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 13px;
}
</style>
